<script lang="ts">
    import {  Button, Input } from "sveltestrap";
    import { Apply, LightLayout } from "../../utils/Constant/Constant";
    import MixLayout from "./MixLayout.svelte";
    let primaryColor ="#26695c"
    let secondaryColor = "#c29873"

    const handleColorChange = () => {
        document.documentElement.style.setProperty('--primary-color', primaryColor);
        document.documentElement.style.setProperty('--secondary-color', secondaryColor);
    };
</script>
<h6>{LightLayout}</h6>
<ul class = 'simple-list flex-row layout-grid unlimited-color-layout'>
    <Input type="color" name="Color-Background1" bind:value={primaryColor}/>
    <Input type="color" name="Color-Background2" bind:value={secondaryColor}/>
    <Button color="primary" class="color-apply-btn color-apply-btn" on:click={handleColorChange}>{Apply}</Button>
</ul>
<MixLayout />